var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCebits2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.06 114.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3f523a;}.cls-2{fill:#317c47;}.cls-3{fill:#c7b299;}.cls-4{fill:#333;}.cls-5{fill:#e6e6e6;}.cls-6{fill:#ffbd2b;}.cls-7{fill:#ccc;}.cls-8{fill:#b3b3b3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.7,
    y: 20.24,
    width: 122.66,
    height: 74.44,
    rx: 6.97,
    ry: 6.97,
    transform: "translate(30.99 -23.9) rotate(25.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 11.22,
    y: 64.67,
    width: 38.92,
    height: 2.9,
    transform: "translate(30.71 139.02) rotate(-155.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 50.23,
    y: 85.48,
    width: 50.34,
    height: 2.9,
    transform: "translate(107.27 197.5) rotate(-155.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.68,33.18l-1.28-.62-2.02,35.46h0c16.71-4.48,18.86-27.31,3.29-34.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.99,54.76l.33,1.38,28.76-20.84h0c-14.03-10.12-33.08,2.63-29.08,19.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 37.28,
    y: 24.68,
    width: 16.77,
    height: 4.31,
    transform: "translate(2.14 57.02) rotate(-65.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 25.1,
    y: 19.03,
    width: 16.77,
    height: 4.31,
    transform: "translate(.21 42.69) rotate(-65.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.7,
    y: 24.3,
    width: 11.28,
    height: 4.31,
    transform: "translate(-1.76 50.16) rotate(-65.19)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.9,
    y: 16.17,
    width: 4.4,
    height: 4.31,
    transform: "translate(7.8 48.85) rotate(-65.19)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 96.45,
    y: 66.34,
    width: 12.14,
    height: 12.57,
    transform: "translate(-8.34 131.75) rotate(-63.39)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCebits2);
export default __webpack_public_path__ + "static/media/cebits2.97767cb7b0aa72d1ade68e62a297ef49.svg";
export { ForwardRef as ReactComponent };